import { Component, OnInit } from '@angular/core';

import { Global } from '../../../../app.global';

import { Constants } from '../../helper/constants';
import { ReportsService } from '../../services/reports.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'teams-reports',
  templateUrl: './teams-reports.component.html',
  styleUrls: ['./teams-reports.component.scss'],
})
export class TeamsReportsComponent implements OnInit {
  constants = Constants;
  teams = [];

  constructor(public global: Global, private reportsService: ReportsService) {}

  ngOnInit() {
    this.setTeams();
  }

  setTeams() {
    this.reportsService.getAllTeamLeaders().subscribe(
      (result) => {
        if (result) {
          this.teams = [];
          result.forEach((team) => {
            team.id = team.id;
            this.teams.push(team);
          });
          this.teams = this.teams.slice();
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }
}
